import { render, staticRenderFns } from "./passo10.vue?vue&type=template&id=139104c3&scoped=true&"
import script from "./passo10.vue?vue&type=script&lang=js&"
export * from "./passo10.vue?vue&type=script&lang=js&"
import style0 from "./passo10.vue?vue&type=style&index=0&id=139104c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139104c3",
  null
  
)

export default component.exports